import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeesModule } from './fees/fees.module';

@NgModule({
  imports: [
    CommonModule,
    FeesModule
  ]
})
export class ConfigsModule { }
